import React from 'react';
import { TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import Menu from '../Menu/Menu';
import { MenuItemProps } from '../Menu/MenuItem';
import { Button, ButtonProps } from '../Button/Button';
import { BaseFilter } from '../../filters/common/BaseFilter';
import { SearchFilter } from '../../../../ui/components/Filter';

// TODO: We should split this up when redesigning the Dashboards
interface SearchBarWithFilterProps<T> {
  testId?: TestIdIdentifier;
  loading?: boolean;
  placeholder?: string;
  filter: BaseFilter<T>;
  items: T[];
  setItems: (items: T[]) => void;

  menuItems?: MenuItemProps[];
  buttons?: ButtonProps[];
  additional?: React.ReactNode[];

  search?: boolean;
}

export default function SearchBarWithFilter<T>({
  loading = false,
  placeholder,
  items,
  setItems,
  testId,
  menuItems,
  buttons,
  additional,
  filter,
  search = true,
}: SearchBarWithFilterProps<T>) {
  return (
    <div className='flex items-center gap-4'>
      <div className='flex-grow'>
        <SearchFilter filter={filter} items={items} setItems={setItems} loading={loading} placeholder={placeholder} />
      </div>
      <div className='flex items-center gap-2'>
        {buttons?.length ? (
          <div className='flex gap-2'>
            {buttons.map((b, index) => (
              <Button {...b} key={index} />
            ))}
          </div>
        ) : null}
        {additional?.length ? additional.map(e => <div key={e?.toString()}>{e}</div>) : null}
        {menuItems?.length ? <Menu items={menuItems || []} /> : null}
      </div>
    </div>
  );
}
